module.exports = __webpack_public_path__ + "img/1780.c607fc45.png";